<script setup>
import { computed, defineAsyncComponent } from 'vue'

const props = defineProps({
  component: {
    type: String,
    required: true
  },
  path: {
    type: String,
    required: true
  }
})

const filtros = import.meta.glob('../filtros/**/*.vue', { eager: true });

const loadCard = async name => {
  if (!name) return;

  const filtro = filtros[`../filtros/${name}.vue`];

  if (!filtro) {
    console.info(`Component ${name}.vue não encontrado!`);
    return;
  }

  return filtro;
}

const is = computed(() =>
  defineAsyncComponent(()=>loadCard(props.component))
)
</script>
<template>
  <component :is="is" v-bind="$props" />
</template>
